import { getFirestore, doc, getDoc, setDoc, updateDoc, serverTimestamp, collection, writeBatch } from "firebase/firestore";
import { app } from "./firebase";  // Ensure correct Firebase initialization
import { v4 as uuidv4 } from "uuid"; 
const db = getFirestore(app); // Firestore instance
/**
 * Stores a chat message in Firestore
 * @param {string} tag - Collection name (e.g., "hmc_logs" or "icici_logs")
 * @param {string} userId - User ID
 * @param {string} sessionId - Session ID
 * @param {string} chatId - chat ID
 * @param {string} query - User query
 * @param {string} response - AI response
 * @param {string} feedback - Optional feedback from user
 */
const storeChatMessage = async (tag, userId, sessionId, chatId, query, response, feedback = "") => {
  try {
    // Validate inputs
    if (!tag || !userId || !sessionId) {
      throw new Error(`Missing required parameters: ${JSON.stringify({
        tag: !!tag,
        userId: !!userId,
        sessionId: !!sessionId
      })}`);
    }

    const sessionRef = doc(db, tag, userId, "sessions", sessionId);
    const chatsCollection = collection(sessionRef, "chats");
    // Create batch write
    const batch = writeBatch(db);
    // Add chat message
    const chatDoc = doc(chatsCollection, chatId);
    batch.set(chatDoc, {
      query: query,
      response: response,
      feedback: feedback,
      time: serverTimestamp(),
      // created_at: new Date().toISOString()
    });
    // Set session data
    const sessionDoc = await getDoc(sessionRef);
    if (!sessionDoc.exists()) {
      // If session doesn't exist, set both start_time and last_updated
      batch.set(sessionRef, {
        start_time: serverTimestamp(),
        last_updated: serverTimestamp()
      });
    } else {
      // If session exists, only update last_updated
      batch.update(sessionRef, {
        last_updated: serverTimestamp()
      });
    }
    // Commit the batch
    await batch.commit();

    console.log("Chat stored successfully!", chatId);
    return chatId;

  } catch (error) {
    console.error("Error storing chat:", {
      error,
      errorCode: error.code,
      errorMessage: error.message,
      tag,
      userId,
      sessionId
    });
    throw error; // Re-throw to handle in calling function
  }
};
/**
 * Updates session end time when the session ends
 * @param {string} tag - Collection name
 * @param {string} userId - User ID
 * @param {string} sessionId - Session ID
 */
const updateSessionEndTime = async (tag, userId, sessionId) => {
  try {
    if (!userId || !sessionId) {
      console.error("Error: userId or sessionId is missing!");
      return;
    }

    const sessionRef = doc(db, tag, userId, "sessions", sessionId);
    await updateDoc(sessionRef, { end_time: serverTimestamp() });
  } catch (error) {
    console.error("Error updating session end time:", error);
  }
};
/**
 * Updates feedback for a specific chat message
 */
const updateChatFeedback = async (tag, userId, sessionId, chatId, feedback) => {
  try {
    if (!chatId || !feedback) throw new Error('chatId and feedback is required');
    // Create the document reference
    const chatRef = doc(db, tag, userId, "sessions", sessionId, "chats", chatId);
      
    // Prepare the update data
    const updateData = {
      feedback: feedback,
      updated_at: serverTimestamp()
    };

    // Update the document
    await updateDoc(chatRef, updateData);

    console.log("Feedback updated successfully");
  } catch (error) {
    console.error("Error updating chat feedback:", {
      error,
      errorCode: error.code,
      errorMessage: error.message,
      tag,
      userId,
      sessionId,
      chatId
    });
    throw error;
  }
};

export { storeChatMessage, updateSessionEndTime, updateChatFeedback };